export const thousandFormatter = (value) => {
    const reverse = value.toString().split('').reverse().join('');
    const thousands = reverse.match(/\d{1,3}/g);

    return thousands.join(' ').split('').reverse().join('');
};
